import { render, staticRenderFns } from "./list-documents.vue?vue&type=template&id=2136666e"
import script from "./list-documents.vue?vue&type=script&lang=ts"
export * from "./list-documents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports